import * as Yup from "yup";

// form field names
export type TFormFieldNames = "dashboard_name";

// initial values for the form
export const formInitialValues = {
  dashboard_name: "",
};

// validation schema for the form
export const YupValidationSchema = Yup.object().shape({
  dashboard_name: Yup.string()
    .required("Please enter the dashboard name"),
});